export enum ColumnType {
  Unknown = 0,
  BooleanType = 1,
  DateTimeType = 2,
  IntegerType = 3,
  DecimalType = 4,
  ShortTextType = 5,
  LongTextType = 6,
  EnumListType = 7,
  ObjectListType = 20,
}
export enum GridColumnType {
  Unknown = "string",
  BooleanType = "boolean",
  DateTimeType = "date",
  IntegerType = "number",
  DecimalType = "number",
  ShortTextType = "string",
  LongTextType = "string",
  EnumListType = "string",
  ObjectListType = "string",
}
export enum SortMode {
  ASC,
  DESC,
}

export {};
